// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__KQ-SF","container":"Modal_container__vt1OF","close":"Modal_close__acG53"};